package fr.frux.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import fr.frux.navigation.openingSearch
import kotlinx.browser.document
import kotlinx.browser.window
import kotlin.js.Date

@Composable
actual fun rememberInstallPrompt(): InstallPrompt? {
    var closed by remember { mutableStateOf(false) }
    val link = remember { computeInstallLink() }
    if (closed || link == null) return null
    return remember(link) {
        InstallPrompt(playUrl = link) {
            closed = true
            rememberDismissal()
        }
    }
}

// Lecture et écriture protégées : navigation privée ou stockage bloqué (ADR 0022) lèvent une
// SecurityError, la bannière s'affiche alors quand même et se referme pour la session.
private fun computeInstallLink(): String? =
    installPromptLink(
        InstallPromptInput(
            userAgent = window.navigator.userAgent,
            search = openingSearch,
            referrerHost = referrerHost(),
            ownHost = window.location.hostname,
            dismissedUntilEpochMs =
                runCatching {
                    window.localStorage
                        .getItem(INSTALL_BANNER_STORAGE_KEY)
                        ?.toDoubleOrNull()
                        ?.toLong()
                }.getOrNull(),
            nowEpochMs = Date.now().toLong(),
        ),
    )

private fun referrerHost(): String? =
    runCatching {
        document.referrer.takeIf { it.isNotEmpty() }?.let {
            org.w3c.dom.url
                .URL(it)
                .hostname
        }
    }.getOrNull()

private fun rememberDismissal() {
    runCatching {
        window.localStorage.setItem(
            INSTALL_BANNER_STORAGE_KEY,
            installBannerDismissUntil(Date.now().toLong()).toString(),
        )
    }
}
